import { all, call, put, select, takeEvery, takeLatest } from 'typed-redux-saga/macro';
import { memberApiV2 } from '../../lib/api';
import TStore from '../../types/store';
import { TUserPreview } from '../../types/users';
import { authActionTypes } from '../ducks/auth';
import { actions as xmppActions } from '../ducks/xmpp';
// import { actions } from '../ducks/e-visits';
import { actions as userActions } from '../ducks/users';
import { authorityStore } from '@components/ui/authorized/authorized.store';
import { TAuthority } from 'types/authority.types';
import { getHilbiUser } from '@services/external/user.api';
import { AxiosResponse } from 'axios';
import EnvService from '@services/internal/env';

function* getCurrentUserRequest({ payload }: any) {
  const withXmpp = payload?.withXmpp;

  try {
    // const doctor: any = yield* call(memberApi.getDoctorProfile);
    const profile: any = yield* call(memberApiV2.getProfile);
    //const profileImage: any = yield* call(memberApi.getProfileImage);

    yield put(
      userActions.getCurrentUserSuccess({
        // ...doctor.data.data,
        ...profile.data.data,
        profile: {
          ...profile.data.data.profile,
          //profileImage: profileImage.data.data.profileImage,
        },
        addresses: (profile.data.data.addresses ?? []).map((a: any) => ({
          ...a,
          country: a.country?.code,
        })),
      }),
    );

    if (withXmpp) {
      const response = yield* all({
        xmppCreds: call(memberApiV2.getXmppCredentials),
        xmppHilbi: call(getHilbiUser),
      });

      const xmppCreds = response.xmppCreds as AxiosResponse<any>;
      const xmppHilbi = response.xmppHilbi as Awaited<ReturnType<typeof getHilbiUser>>;

      yield put(
        xmppActions.connectionRequest({
          username: profile.data.data.jabberId,
          password: xmppCreds.data.data.jabberPassword,
        }),
      );

      EnvService.setEnv({
        xmpp: { hilbiJid: xmppHilbi.data.data.jabberId, hilbiId: xmppHilbi.data.data.id },
      });
    }

    yield put({
      type: authActionTypes.GET_LOGIN_SUCCESS,
      payload: true,
    });

    yield put({
      type: authActionTypes.SET_LOADING,
      payload: false,
    });
  } catch (e) {
    console.error('EE', e);
    yield put({
      type: authActionTypes.SET_LOADING,
      payload: false,
    });
  }
}

function* postSearchRequest({ payload }: any) {
  try {
    let shouldSendRequest = true;

    // on room messages callback might send to many requests
    // check if user is already searched
    if (payload.jabberIds && payload.jabberIds.length === 1) {
      const searches: TUserPreview[] = yield select((store: TStore) => store.users.searchHistory);
      const alreadySearched = searches.find((user) => user.jabberId === payload.jabberIds[0]);
      if (alreadySearched) {
        shouldSendRequest = false;
      }
    }

    if (shouldSendRequest) {
      const searchReq: any = yield* call(memberApiV2.searchUsers, payload.providerId, {
        name: payload.name || null,
        phoneNumbers: payload.phoneNumbers
          ? payload.phoneNumbers.length === 0
            ? null
            : payload.phoneNumbers
          : null,
        jabberIds: payload.jabberIds
          ? payload.jabberIds.length === 0
            ? null
            : payload.jabberIds
          : null,
      });
      yield put(userActions.postSearchSuccess(searchReq.data.data.items));
    }
  } catch (err) {
    console.log(err);
  }
}

function* setCurrentPermissions({ payload }: ReturnType<typeof userActions.setCurrentPermissions>) {
  authorityStore.setAuthority(payload as TAuthority[]);
}

function* usersSaga() {
  yield takeLatest(userActions.getCurrentUserRequest, getCurrentUserRequest);
  yield takeEvery(userActions.postSearchRequest, postSearchRequest);
  yield takeLatest(userActions.setCurrentPermissions, setCurrentPermissions);
}

export default usersSaga;
